import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Topbar from '../components/Topbar'
import Sidebar from '../components/Sidebar'
import styles from '../assets/css/AttendenceReport.module.css'
import { FaSearch, FaCalendarAlt } from 'react-icons/fa'

function AttendenceReport() {
  const { section } = useParams()
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [searchQuery, setSearchQuery] = useState('')

  // Mock data - replace with actual data
  const attendanceData = [
    {
      id: 1,
      name: 'John Doe',
      month: 'March 2024',
      totalWorkingDays: 22,
      presentDays: 20,
      leaves: 2
    },
    {
      id: 2,
      name: 'Jane Smith',
      month: 'March 2024',
      totalWorkingDays: 22,
      presentDays: 18,
      leaves: 4
    },
    // Add more mock data as needed
  ]

  const filteredData = attendanceData.filter(employee => 
    employee.name.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const handleDateFilter = () => {
    // Implement date filtering logic here
    console.log('Filtering by date range:', startDate, endDate)
  }

  return (
    <>
      <Topbar />
      <div className='d-flex'>
        <Sidebar />
        <div className={styles.reportContainer}>
          <div className={styles.reportContent}>
            <div className={styles.reportHeader}>
              <h2 className={styles.pageTitle}>
                {section.toUpperCase()} Section Attendance Report
              </h2>
            </div>

            <div className={styles.filterSection}>
              <div className={styles.dateFilters}>
                <div className={styles.dateInputGroup}>
                  <FaCalendarAlt className={styles.calendarIcon} />
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className={styles.dateInput}
                  />
                </div>
                <span className={styles.dateSeparator}>to</span>
                <div className={styles.dateInputGroup}>
                  <FaCalendarAlt className={styles.calendarIcon} />
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className={styles.dateInput}
                  />
                </div>
                <button 
                  className={styles.filterButton}
                  onClick={handleDateFilter}
                >
                  Apply Filter
                </button>
              </div>

              <div className={styles.searchBox}>
                <FaSearch className={styles.searchIcon} />
                <input
                  type="text"
                  placeholder="Search employee..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className={styles.searchInput}
                />
              </div>
            </div>

            <div className={styles.tableContainer}>
              <table className={styles.reportTable}>
                <thead>
                  <tr>
                    <th>Employee Name</th>
                    <th>Month</th>
                    <th>Total Working Days</th>
                    <th>Present Days</th>
                    <th>Leaves</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map(employee => (
                    <tr key={employee.id}>
                      <td>{employee.name}</td>
                      <td>{employee.month}</td>
                      <td>{employee.totalWorkingDays}</td>
                      <td>{employee.presentDays}</td>
                      <td>{employee.leaves}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AttendenceReport 